var map = {
	"./ABCD/A.mp3": "0bee",
	"./ABCD/B.mp3": "d769",
	"./ABCD/C.mp3": "16b3",
	"./ABCD/D.mp3": "bd63",
	"./ABCD/E.mp3": "ae3e",
	"./ABCD/F.mp3": "92f2",
	"./ABCD/G.mp3": "7e45",
	"./ABCD/H.mp3": "afd8",
	"./ABCD/I.mp3": "b5cc",
	"./ABCD/J.mp3": "0d5d",
	"./ABCD/K.mp3": "dce1",
	"./ABCD/L.mp3": "66e7",
	"./ABCD/M.mp3": "d02c",
	"./ABCD/N.mp3": "5618",
	"./ABCD/O.mp3": "763e",
	"./ABCD/P.mp3": "148e",
	"./ABCD/Q.mp3": "3f8d",
	"./ABCD/R.mp3": "e97e",
	"./ABCD/S.mp3": "fc2f",
	"./ABCD/T.mp3": "2e5c",
	"./ABCD/U.mp3": "a629",
	"./ABCD/V.mp3": "d795",
	"./ABCD/W.mp3": "54e3",
	"./ABCD/X.mp3": "17a8",
	"./ABCD/Y.mp3": "2b94",
	"./ABCD/Z.mp3": "0000",
	"./Lecturas/Cumprimentos.mp3": "c9bd",
	"./Lecturas/Dialogo com as expressoes cotidianas.mp3": "db3e",
	"./Lecturas/Uma pessoa mais velha deve sempre ser.mp3": "9d56",
	"./slide1/fragment_1.mp3": "d33d",
	"./slide1/fragment_2.mp3": "e248",
	"./slide10/Avo.mp3": "2165",
	"./slide10/Calma.mp3": "aba9",
	"./slide10/Do.mp3": "bbcf",
	"./slide10/Farol.mp3": "ab8c",
	"./slide10/Forro.mp3": "3ae5",
	"./slide10/Guru.mp3": "3b9e",
	"./slide10/Metro.mp3": "cb90",
	"./slide10/Prato.mp3": "5641",
	"./slide10/Sul.mp3": "5910",
	"./slide14/Aceite.mp3": "8240",
	"./slide14/Carate.mp3": "8b53",
	"./slide14/Cidade.mp3": "8f2e",
	"./slide14/Diamante.mp3": "cf75",
	"./slide14/Doce.mp3": "a6df",
	"./slide14/Taxi.mp3": "9965",
	"./slide14/Tigre.mp3": "a3e3",
	"./slide15/Adiantar.mp3": "edb3",
	"./slide15/Cafe.mp3": "386b3",
	"./slide15/Civis.mp3": "1302",
	"./slide15/Dicas.mp3": "9471",
	"./slide15/Doce.mp3": "f8e7",
	"./slide15/Felicidade.mp3": "87a8",
	"./slide15/Mente.mp3": "8073",
	"./slide15/Politica.mp3": "d546",
	"./slide15/Saudade.mp3": "30b5",
	"./slide15/Voce.mp3": "80b4",
	"./slide19/ibra11-1.mp3": "62b7",
	"./slide19/ibra11-2.mp3": "e1ef",
	"./slide19/ibra11-3.mp3": "1244",
	"./slide19/ibra11-4.mp3": "5b35",
	"./slide5/Estou, sim.mp3": "4b8b",
	"./slide5/Estou.mp3": "69aa",
	"./slide5/Nao estou nao.mp3": "58d5",
	"./slide5/Nao estou.mp3": "7eda",
	"./slide5/Nao, estou nao.mp3": "7cfb",
	"./slide5/Nao, nao estou.mp3": "9621",
	"./slide5/Nao.mp3": "cc54",
	"./slide5/Sim, estou.mp3": "7ef9",
	"./slide5/Sim.mp3": "a8ba",
	"./slide9/Barco.mp3": "81f0",
	"./slide9/Farol.mp3": "352c",
	"./slide9/Onibus.mp3": "d36f",
	"./slide9/urubu.mp3": "02a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d75d";